import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { namespaceInstallableContent } from '@next-adapter/installable-runtime/namespace-installable-content.js'
import { readTemplate } from '@next-adapter/template-reader/read-template.js'

export function renderCoreStorageProviderIndex(config: ResolvedBetterstartConfig): string {
  return namespaceInstallableContent(config, readTemplate('lib/actions/storage/index.ts'))
}
